import ApiInstance from "./ApiInstance.js";

export default {
  getSingleProfileWithData(id) {
    return ApiInstance({ requiresAuth: true }).get(
      `student-profile-with-data/${id}`
    );
  },
  getStdCareerProfle() {
    return ApiInstance({ requiresAuth: true }).get("/std-career-profile");
  },

  saveStdCareerProfle(formData) {
    return ApiInstance({ requiresAuth: true }).post(
      "/std-career-profile",
      formData
    );
  },

  saveStdMentorProfle(formData) {
    return ApiInstance({ requiresAuth: true }).post(
      "/std-mentor-profile",
      formData
    );
  },
};
